import { Component, OnDestroy, OnInit } from '@angular/core';
import { TabStorageService } from 'src/app/multiply-tab/tab-storage.service';
import { DataManagerService } from '@services/data-manager.service';
import { VocabularyService } from 'src/app/vocabularies/vocabulary.service';
import { CurrentWorkgroupService } from '@services/current-workgroup.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'climb-main',
    templateUrl: './main.layout.html',
    styleUrls: ['./main.layout.scss'],
})
export class MainLayoutComponent implements OnInit, OnDestroy {

    private subs: Subscription = new Subscription();

    constructor(
        private tabStorage: TabStorageService,
        private dataManagerService: DataManagerService,
        private vocabularyService: VocabularyService,
        private currentWorkgroupService: CurrentWorkgroupService,
    ) {}

    ngOnInit(): void {
        this.tabStorage.init();
        this.vocabularyService.resetCache();

        this.subs.add(
            this.currentWorkgroupService.switchWorkgroup$.subscribe(() => {
                this.vocabularyService.resetCache();
            })
        );
    }

    ngOnDestroy(): void {
        this.dataManagerService.cancel();
        this.tabStorage.destroy();
        this.subs.unsubscribe();
    }
}
